module.exports = __webpack_public_path__ + "static/img/logout.f0357277.svg";